<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Modules",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Modules",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Modules",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Module Name",
          sortable: true,
        },
        {
          key: "short",
          label: "Short Name",
          sortable: true,
        },
        {
          key: "class_details.name",
          label: "Level",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        short: "",
        classes: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        short: "",
        id: "",
      },
      existingSubject: [],
      nameError: "",
      shortError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("classes", ["AllSubjects", "SaveStatus", "AllClasses"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllSubjects ? this.AllSubjects.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllSubjects ? this.AllSubjects.length : 1;
  },
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchSubjects: "classes/fetchSubjects",
      AddSubject: "classes/addSubject",
      EditSubject: "classes/editSubject",
      DeleteSubjects: "classes/deleteSubject",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllSubjects ? this.AllSubjects.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
      this.shortError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.short = "";
      this.data.clss = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.short = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingSubject = this.AllSubjects
          ? this.AllSubjects.filter((subj) => {
              return subj.name.toUpperCase() == this.data.name.toUpperCase();
            })
          : [];
        if (this.existingSubject.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingSubject = [];
      }
    },
    addSubject(modal) {
      if (this.data.name == "") {
        this.nameError = "Module Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.short == "") {
        this.shortError = "Module Short Name field can't be empty";
        return;
      } else {
        this.shortError = "";
      }
      if (this.existingSubject.length) {
        this.nameError = this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddSubject(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.name;
      this.editdata.short = values.item.short;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteSubject(modal) {
      this.modal = modal;
      this.DeleteSubjects(this.deletedata);
      this.closeModal(modal);
    },
    editSubject(modal) {
      if (this.editdata.name == "") {
        this.nameError = "Module field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.short == "") {
        this.shortError = "Module Short Name field can't be empty";
        return;
      } else {
        this.shortError = "";
      }
      this.modal = modal;
      this.EditSubject(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchSubjects();
    this.FetchClasses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_subject')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Available Modules
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-subject-modal
                  class="btn-sm btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_subject')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add Module
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllSubjects"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-subject-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_subject')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-subject-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_subject')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-subject-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_subject')
          )
        "
      >
        <template #modal-title> Add New Module </template>
        <div class="form-group mb-3">
          <label>Module Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Module Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Short Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Short Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.short"
            />
          </div>
          <div class="text-danger" v-if="shortError">
            <em>{{ shortError }}</em>
          </div>
        </div>
        <div class="form-group mb-2">
          <label
            >Levels <br />
            <small class="text-primary"
              >(Select level(s) where module is to be tought.)</small
            >
          </label>
          <div class="input-group">
            <multiselect
              v-model="data.classes"
              :height="300"
              :options="AllClasses ? AllClasses : []"
              :multiple="true"
              :taggable="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              tag-placeholder="Add a class"
              placeholder="Search or add a class"
              label="name"
              track-by="id"
              :preselect-first="false"
              @input="resetError()"
            >
              <template slot="selection" slot-scope="{ values, isOpen }"
                ><span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} Level(s) Selected</span
                ></template
              >
            </multiselect>
          </div>
          <!-- <div class="text-danger" v-if="classError">
            <em>{{ classError }}</em>
          </div> -->
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-sm btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('add-subject-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn-sm btn btn-outline-primary"
            @click="addSubject('add-subject-modal')"
          >
            <i class="fa fa-check"></i>
            Submit Module
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-subject-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_subject')
          )
        "
      >
        <template #modal-title> Edit Module {{ editdata.name }}</template>
        <div class="form-group mb-3">
          <label>Module Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editdata.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Short Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Short Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="editdata.short"
            />
          </div>
          <div class="text-danger" v-if="shortError">
            <em>{{ shortError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-sm btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('edit-subject-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn-sm btn btn-outline-primary"
            @click="editSubject('edit-subject-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete subject starts -->
      <b-modal
        id="delete-subject-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_subject')
          )
        "
      >
        <template #modal-title>
          <h5 class="text-danger">
            Delete Module <strong>{{ deletedata.name }}</strong>
          </h5></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h6>
              Do you want to delete Module,
              <strong>{{ deletedata.name }}</strong
              >?
              <br />
              <br />
              <strong>Click Proceed Button to delete.</strong>
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-sm btn btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-subject-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn-sm btn btn-outline-danger"
            @click="deleteSubject('delete-subject-modal')"
          >
            <i class="fa fa-trash"></i> Procees</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
